"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var useEventListener = function useEventListener(eventName, handler, element) {
  var _element;

  element = ((_element = element) !== null && _element !== void 0 ? _element : typeof window !== "undefined") ? window : undefined;
  var savedHandler = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedHandler.current = handler;
  }, [handler]);
  (0, _react.useEffect)(function () {
    var _element2;

    if (!element) {
      return;
    } // Make sure element supports addEventListener
    // On


    var isSupported = Boolean((_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.addEventListener);

    if (!isSupported || !savedHandler) {
      return;
    } // Create event listener that calls handler function stored in ref


    var eventListener = function eventListener(event) {
      if (!(savedHandler !== null && savedHandler !== void 0 && savedHandler.current)) {
        return;
      }

      return savedHandler.current(event);
    }; // Add event listener


    element.addEventListener(eventName, eventListener); // Remove event listener on cleanup

    return function () {
      if (!element) {
        return;
      }

      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element] // Re-run if eventName or element changes
  );
};

var _default = useEventListener;
exports["default"] = _default;